import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { getTargetDetail } from 'config/api';
import { PremiumCheck2 as PremiumCheck } from 'components/commons/premium-check/PremiumCheck';
import Loading from 'components/commons/loading/Loading';
import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { Target, TargetModalStatus, TargetType } from '../utils/type';
import { targetToHowToSave } from '../utils/targetInfo';
import { useBirthday } from '../utils/birthday';
import { NotFoundBirthday } from '../components/features/birthday/NotFoundBirthday';
import { TargetPremium } from '../components/features/TargetPremium';
import { TargetOnly } from '../components/features/detail/TargetOnly';
import { TargetInformation } from '../components/features/detail/TargetImformation';

const TargetDetail = (): React.ReactElement => {
  const { id } = useParams<{ id: string }>();
  const { setWithBackIconWord } = useCustomizeHeaderContext();
  useEffect(() => {
    setWithBackIconWord();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data, isFetching } = useQuery(
    'targetDetailTargetDetail',
    () => getTargetDetailAPI(id),
    {
      refetchOnWindowFocus: false,
    }
  );

  const { birthday } = useBirthday();

  if (data === null || data === undefined || isFetching)
    return <Loading loading style={{ marginTop: '3rem' }} />;

  if (birthday === null || birthday === undefined)
    return (
      <>
        <PremiumCheck content={<TargetPremium />}>
          <NotFoundBirthday />
        </PremiumCheck>
      </>
    );

  const howToSave = targetToHowToSave(data);

  return (
    <PremiumCheck content={<TargetPremium />}>
      {howToSave.tag === 'reserveAmountRegistered' ? (
        <TargetInformation
          {...{
            target: data,
            birthday,
            targetHowToSaveType: howToSave.type,
          }}
        />
      ) : (
        <TargetOnly {...{ target: data, birthday }} />
      )}
    </PremiumCheck>
  );
};

const getTargetDetailAPI = async (id: string) => {
  const res_ = await getTargetDetail(id);
  const res = {
    id: res_.ID,
    title: res_.Title,
    refType: res_.RefType as TargetType,
    startDate: res_.StartDate,
    endDate: res_.EndDate,
    targetAmount: res_.TargetAmount,
    accountList: res_.AccountList.map(list => {
      return {
        account: list.Account,
        brokerName: list.BrokerName,
        available: list.Available,
        totalAssetAmount: list.TotalAssetAmount,
      };
    }),
    excludeAmount: res_.ExcludeAmount,
    reserveAmount: res_.ReserveAmount,
    assetAmount: res_.AssetAmount,
    yield: res_.Yield,
    achieved: res_.Achieved,
    status: res_.Status as TargetModalStatus,
  };

  return res as Target;
};

export default TargetDetail;
